import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-recovery-password-comfirm',
  imports: [TranslateModule, RouterModule],
  templateUrl: './recovery-password-comfirm.component.html',
  standalone: true,
  styleUrl: './recovery-password-comfirm.component.scss'
})
export class RecoveryPasswordComfirmComponent {

}
